import { render, staticRenderFns } from "./admin-members.vue?vue&type=template&id=1edd1ca0&scoped=true"
import script from "./admin-members.vue?vue&type=script&lang=js"
export * from "./admin-members.vue?vue&type=script&lang=js"
import style0 from "./admin-members.vue?vue&type=style&index=0&id=1edd1ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd1ca0",
  null
  
)

export default component.exports